import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App.jsx';
import { LanguageProvider } from './i18n/LanguageContext.jsx';
import { initAnalytics } from './analytics.js';
import { installPreloadErrorReload } from './lib/preloadErrorReload.js';

// Initialize Google Analytics (no-op if VITE_GA_MEASUREMENT_ID is not set)
initAnalytics();

// Guard against stale-deploy 404s on lazy chunks (routes + GoldenBootPanel).
// When Vite fires vite:preloadError (old tab, new chunk hashes), reload once.
installPreloadErrorReload();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>
);
